import type { FaireProductEntity } from "../../entity_types/product";

export const p_8hvty77kwp: FaireProductEntity = {
  token: "p_8hvty77kwp",
  type: "product",
  name: "Eucalyptus & Pink Larkspur Mini Bouquet #57",
  brandToken: "b_3ga4euf8eq",
  brandName: "Andaluca",
  imageUrl:
    "https://cdn.faire.com/fastly/f3419fff99d51004ec2e3511b7d6051097f72cc8e246172b7d44ce832f10ef4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/c59dd5ac0aebe92af2ffbeeb4784c1fed61f569c750e83995e17aaa51e7da5a8.jpeg",
    "https://cdn.faire.com/fastly/628c950910c605f5b5a307cb43dc4eb6ef93403792be7a4cd21acddc8f8afb8f.jpeg",
    "https://cdn.faire.com/fastly/410ae643add150e7ea99d102fafca43c6bea6cdb669eecb16fc258f715eff72f.jpeg",
    "https://cdn.faire.com/fastly/bed1effe468a64131d70386e3edf3351f6fae5cdb92f77604c7e49355182456d.jpeg",
    "https://cdn.faire.com/fastly/36b78064fa4192511dc2c013fadcd8663a733a4a67f5fd20ea74b0ac1d3dd73e.jpeg",
    "https://cdn.faire.com/fastly/99e005128b83a8b85545bd73cecfa37afd22c0fe9e7aba48dce80790726e372e.jpeg",
  ],
  priceDollars: 8.22,
  description:
    'Our floral team designed this beautiful MINI bouquet using an assortment of baby eucalyptus, willow, and pink larkspur to create this charming and petit mini bouquet arrangement.  Each bouquet is designed and handcrafted in our California design studio and is a perfect decorative accent to your tablescape or vignette.\n\n- 8" long\n- Comes in packs of 6.\n- Each bouquet is placed in a decorative paper card.\n',
  tags: [],
  msrpDollars: 16.44,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:22:39.446Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
